var _style, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage11Layer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 549.93 449.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff;stroke:#fff;stroke-miterlimit:10}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 241.94,
    cy: 220.37,
    r: 202.36,
    fill: "#fc0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.1 115.4l-21.89-43.2h-6.57l21.89 43.2zM180.73 115.4l-21.89-43.2h-6.57l21.89 43.2zM204.36 115.4l-21.89-43.2h-6.57l21.89 43.2zM227.99 115.4 206.1 72.2h-6.57l21.89 43.2zM251.62 115.4l-21.89-43.2h-6.57l21.89 43.2zM275.24 115.4l-21.89-43.2h-6.56l21.89 43.2zM298.87 115.4l-21.89-43.2h-6.57l21.89 43.2zM322.5 115.4l-21.89-43.2h-6.57l21.89 43.2zM346.13 115.4l-21.89-43.2h-6.57l21.89 43.2zM369.76 115.4l-21.89-43.2h-6.57l21.89 43.2zM393.39 115.4 371.5 72.2h-6.57l21.89 43.2z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff95b",
    d: "M520.22 49.05h-35.06V13.99h-34.62v35.06h-35.06v34.63h35.06v35.05h34.62V83.68h35.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage11Layer2);
export default __webpack_public_path__ + "static/media/image-11-layer-2.13cc3e424471ab7648cb39c75b0fa11a.svg";
export { ForwardRef as ReactComponent };